import React, { useEffect, useState } from "react";
import "./welcome.scss";
import { useHistory } from "react-router-dom";
import { formatTime, formatDay } from "@/utils/helper";
import WelcomeLoader from "../../WelcomeLoader/WelcomeLoader";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import LoginForm from "../../Login/LoginForm";
import { eventRoomStore } from "@/stores/event";
import HeaderGuide from "../Header";
import { isAndroid, isIOS } from "react-device-detect";
import { globalStore } from "@/stores/global";
import MapContainer from "@/components/MapContainer";

const GuideWelcome = (props: any) => {
  const [isLoader, setisLoader] = useState(false);
  if (!Cookies.get("token")) {
    return <LoginForm />;
  }
  const history = useHistory();
  const visit = props?.visit_id || props?.visit?.id;
  const [GuideDetails, setGuideDetails] = useState<any>(props?.visit);

  const guideDetails = GuideDetails?.guide_details || {};
  const structureDetails = GuideDetails?.structure_details || {};
  const themeDetails = GuideDetails?.theme_details || {};

  const resolveLocalizedValue = (value: any) => {
    if (!value) {
      return "";
    }

    if (typeof value === "string") {
      return value;
    }

    if (typeof value === "object") {
      return value.fr || value.en || Object.values(value).find((entry) => Boolean(entry)) || "";
    }

    return String(value);
  };

  const formatUserName = (user: any) => {
    if (!user) {
      return "";
    }

    const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
    return fullName || user.name || user.username || user.email || "";
  };

  const buildIsoDateTime = (dateValue: any, timeValue: any) => {
    if (!dateValue || !timeValue) {
      return "";
    }

    const rawTime = String(timeValue);
    const normalizedTime = rawTime.length === 5 ? `${rawTime}:00` : rawTime;
    const candidate = `${dateValue}T${normalizedTime}`;
    const parsed = new Date(candidate);
    return Number.isNaN(parsed.getTime()) ? candidate : parsed.toISOString();
  };

  const guideName = GuideDetails?.guide_name || formatUserName(guideDetails);
  const visitName = GuideDetails?.visit_name || `${resolveLocalizedValue(themeDetails.name)}${resolveLocalizedValue(structureDetails.name) ? ` - ${resolveLocalizedValue(structureDetails.name)}` : ""}`;
  const timeInUtc = GuideDetails?.time_in_utc || (GuideDetails?.date && GuideDetails?.time ? buildIsoDateTime(GuideDetails.date, GuideDetails.time) : "");
  const residenceName = GuideDetails?.residence_name || structureDetails.display_name || resolveLocalizedValue(structureDetails.name);
  const residenceType = GuideDetails?.residence_type || structureDetails.structure_type || structureDetails.type_display || structureDetails.type;
  const city = GuideDetails?.city || structureDetails.city || structureDetails.region;
  const postalCode = GuideDetails?.postalCode || structureDetails.zip_code || structureDetails.postal_code;
  const notes = GuideDetails?.details || resolveLocalizedValue(themeDetails.description);
  const comments = GuideDetails?.comments || resolveLocalizedValue(themeDetails.will_discover);
  const residenceLat = GuideDetails?.residence_latitude ?? structureDetails.lat;
  const residenceLng = GuideDetails?.residence_longitude ?? structureDetails.lng;
  const guideLat = GuideDetails?.guide_latitude ?? guideDetails.lat;
  const guideLng = GuideDetails?.guide_longitude ?? guideDetails.lng;

  const joinVisit = (time: any) => {
    if (eventRoomStore.canStartVisit(time)) {
      if (isAndroid || isIOS) {
        history.push(`/handlenative/${visit}`);
      } else {
        history.push(`/meeting/${visit}`);
      }
    } else {
      toast.error("You are not Allowed to Join before 20 minutes");
    }
  };

  useEffect(() => {
    globalStore.stopLoading();
    setGuideDetails(props?.visit);
  }, [props?.visit]);

  return (
    <>
      <div className="guide-welcome">
        <HeaderGuide showLogout={false} />
        {isLoader ? (
          <WelcomeLoader />
        ) : (
          <div className="guide-welcome-content">
            <div className="guide-welcome-content-name">
              Hello {guideName}
              <button
                onClick={() => {
                  joinVisit(timeInUtc);
                }}
                className="guide-welcome-content-button"
              >
                ENTER THE VISIT
              </button>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">Your visit</span>
              <div className="guide-welcome-content-header">
                {visitName}
              </div>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">Date</span>
              <div className="guide-welcome-content-header">
                {formatDay(
                  eventRoomStore.convertTimeFromUTC(timeInUtc)
                )}{" "}
              </div>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">Hour</span>
              <div className="guide-welcome-content-header">
                {formatTime(
                  eventRoomStore.convertTimeFromUTC(timeInUtc)
                )}
              </div>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">With</span>
              <div className="guide-welcome-content-header">
                {residenceName}
                {GuideDetails?.new_visit_level && (
                  <span className="guide-welcome-content-header-new">
                    {GuideDetails.new_visit_level}
                  </span>
                )}
              </div>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">Type</span>
              <div className="guide-welcome-content-header">
                {` ${residenceType || ""}`}
              </div>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">Location</span>
              <div className="guide-welcome-content-header">
                {city} ,{postalCode}
              </div>
            </div>
            <div className="guide-welcome-list">
              <span className="list-name">Note</span>
              <div className="guide-welcome-content-header">
                {notes}
              </div>
            </div>
            {comments && (
              <div className="guide-welcome-list" style={{ backgroundColor: "#fff3cd", padding: "10px", borderRadius: "8px", marginTop: "10px" }}>
                <span className="list-name" style={{ color: "#856404" }}>Comments</span>
                <div className="guide-welcome-content-header" style={{ color: "#856404", fontWeight: "bold" }}>
                  {comments}
                </div>
              </div>
            )}
            <div className="inside-map-container">
              <MapContainer
                coordinates={{
                  residence: { lat: residenceLat, lng: residenceLng },
                  guide: { lat: guideLat, lng: guideLng },
                }}
                eventDetail={GuideDetails}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default GuideWelcome;
